import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
html {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: 'Roboto', sans-serif !important;
}
*, *:before, *:after {
  box-sizing: inherit;
}

 *{
 font-family: inherit;
 }
body {
  font-family: 'Roboto', sans-serif !important;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  line-height: 1.5;
  margin: 0;
  padding: 0;
}

html, body { // responsive nav bar is 50px height
scroll-padding-top: 50px;
}

//#services, #work, #clients, #contact {
//    border-top: 50px solid transparent;
//    margin-top: -50px;
//    background-clip: padding-box;
//}

h1, h2, h3 , h4 ,h5 ,h6 {
margin: 0;
}

a, a:hover, a:focus, a:active  {
text-decoration: none !important;
}

.jump-target::before {
  content:" ";
  display:block;
  height:50px; /* fixed header height*/
  margin:-50px 0 0; /* negative fixed header height */
  visibility: hidden;
}
 `;

export default GlobalStyle;
